// Route names
export const ROUTE_NAME_LOGIN = 'login';
export const REDIRECTION_URL = 'REDIRECTION_URL';

// Toast Message
export const TOAST_MESSAGE_POSITION_TOP_RIGHT = 'top-right';
export const TOAST_MESSAGE_POSITION_TOP_CENTER = 'top-center';
export const TOAST_MESSAGE_POSITION_TOP_LEFT = 'top-left';
export const TOAST_MESSAGE_POSITION_BOTTOM_RIGHT = 'bottom-right';
export const TOAST_MESSAGE_POSITION_BOTTOM_CENTER = 'bottom-center';
export const TOAST_MESSAGE_POSITION_BOTTOM_LEFT = 'bottom-left';
export const TOAST_MESSAGE_TYPE_SUCCESS = 'success';
export const TOAST_MESSAGE_TYPE_ERROR = 'error';
export const TOAST_MESSAGE_TYPE_WARNING = 'warning';
export const TOAST_MESSAGE_TYPE_INFO = 'info';

// Stateful UI
export const UI_STATE_SUCCESS = 'SUCCESS';
export const UI_STATE_FAILURE = 'FAILURE';
export const UI_STATE_LOADING = 'LOADING';
export const UI_STATE_EMPTY = 'EMPTY';
